import { Component, inject } from '@angular/core';
import {
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef
} from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-error-snackbar',
  templateUrl: 'error-snackbar.component.html',
  styleUrls: ['error-snackbar.component.scss'],
  imports: [MatButtonModule, MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction]
})
export class ErrorSnackbarComponent {
  snackBarRef = inject(MatSnackBarRef);
}
